import type {
  CheckResponseData,
  GenerateResponseData,
  GenerationStyle,
  GameType,
  LanguageCode,
  PlatformDefinition,
  PlatformId
} from "@handlequest/shared";

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
  error?: {
    code: string;
    message: string;
    details?: unknown;
  };
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...init?.headers
    }
  });
  const payload = await response.json() as ApiEnvelope<T>;
  if (!response.ok || !payload.success || !payload.data) {
    throw new Error(payload.error?.message || `Request failed with HTTP ${response.status}`);
  }
  return payload.data;
}

export function getPlatforms(): Promise<{ platforms: PlatformDefinition[] }> {
  return request("/api/platforms");
}

export function checkUsername(username: string, platforms: PlatformId[], turnstileToken?: string): Promise<CheckResponseData> {
  return request("/api/check", {
    method: "POST",
    body: JSON.stringify({ username, platforms, ...(turnstileToken ? { turnstileToken } : {}) })
  });
}

export function generateNames(params: {
  style: GenerationStyle;
  gameType: GameType;
  keywords: string[];
  language: LanguageCode;
  count: number;
  turnstileToken?: string;
}): Promise<GenerateResponseData> {
  return request("/api/generate", {
    method: "POST",
    body: JSON.stringify(params)
  });
}

export function shareCardUrl(username: string, available: number, total: number): string {
  const search = new URLSearchParams({
    username,
    available: String(available),
    total: String(total)
  });
  return `${API_BASE}/api/share/card?${search.toString()}`;
}
